export class CreateDocumentosIntervencaoReadaptacaoDTO {
  profissionalReadaptacaoMatriculaId: string;
  dadosBimestres: DadosBimestresCreateDTO[];

  constructor(obj?: any) {
    if (obj) {
      this.profissionalReadaptacaoMatriculaId = tratarPropriedades(obj.profissionalReadaptacaoMatriculaId);
      this.dadosBimestres = obj.dadosBimestres.map((item: any) => new DadosBimestresCreateDTO(item)) || [];
    }
  }
}

export class DadosBimestresCreateDTO {
  id?: string;
  tipoDocumento: string;
  bimestre: number | null;
  arquivo: UploadArquivoDTO;
  ano: number | string;
  comentario: string;
  dimensoesProjetoIds: string[];

  constructor(obj?: any) {
    if (obj) {
      this.id = tratarPropriedades(obj.id);
      this.tipoDocumento = tratarPropriedades(obj.tipoDocumento?.value);
      this.bimestre = obj.bimestre || null;
      this.arquivo = obj.arquivo ? new UploadArquivoDTO(obj.arquivo) : null;
      this.ano = tratarPropriedades(obj.ano);
      this.comentario = tratarPropriedades(obj.comentario);
      this.dimensoesProjetoIds = obj.dimensoesProjetoIds?.map((item: any) => item?.id || null) || [];
    }
  }
}

export class UploadArquivoDTO {
  id?: string;
  base64?: string;
  nome?: string;
  extensao?: string;
  acao?: string;
  constructor(obj?: any) {
    if (obj) {
      this.id = tratarPropriedades(obj.id);
      this.base64 = tratarPropriedades(obj.base64);
      this.nome = tratarPropriedades(obj.nome);
      this.extensao = tratarPropriedades(obj.extensao);
      this.acao = tratarPropriedades(obj.acao);
    }
  }
}

function tratarPropriedades(propriedade: any): string {
  if (!propriedade) return '';
  return propriedade;
}
